import { Injectable } from '@angular/core';
import { DbTableDefinition } from 'src/app/_services/persistence/db-persistence/db-table-definition';

@Injectable({
  providedIn: 'root',
})
export class CellphoneDbTableDefinition extends DbTableDefinition {
  tableName = 'cellphones';
  tableStructure = `(id BIGINT(20) PRIMARY KEY null,
     label TEXT NOT NULL,
     phonenumber TEXT,
     phonenumber_cleartext TEXT,
     name TEXT,
     imei TEXT,
     type TEXT,
     brand TEXT,
     typename TEXT,
     employeeid BIGINT(20),
     employeelabel TEXT,
     mobileclientid BIGINT(20),
     mobileclientlabel TEXT,
     databag LONGTEXT
    );`;

  constructor() {
    super();
    this.updateStatements.set(30, [
      `CREATE TABLE IF NOT EXISTS ${this.tableName}${this.tableStructure}`,
    ]);
  }
}
